import React from 'react'

import LogosList from 'components/shared/LogosList'
import Layout from 'components/shared/Layout'

import GradientHeaderWithIntro from 'components/shared/GradientHeaderWithIntro'
import css from './styles.module.scss'

const BrandsWithIntro = ({ className, brands, gradientHeader, intro, topIntegrations }) => {
  const hasBrandsFromTopIntegrations = topIntegrations?.brands?.length > 0
  const brandsToDisplay = hasBrandsFromTopIntegrations ? topIntegrations.brands : brands
  
  return (
  <GradientHeaderWithIntro
    gradientHeader={gradientHeader}
    intro={intro}
    className={className}
  >
    <Layout type="wrapper" className={css.wrapper}>
      <LogosList brands={brandsToDisplay} />
    </Layout>
  </GradientHeaderWithIntro>
)}

BrandsWithIntro.defaultProps = {
  brands: [],
}

export default BrandsWithIntro
